import styled from 'styled-components'

import FormikForm from '../../../form/FormikForm'
import FormSubmitButton from '../../../form/FormSubmitButton'
import FormErrors from '../../../form/FormErrors'
import Card from '../../../Card'
import breakpoints from '../../../../theme/breakpoints'
import FormFieldCheckbox from '../../../form/fields/FormFieldCheckbox'
import CBoxedContent from '../../../BoxedContent'

export const BoxedContent = styled(CBoxedContent)`
  padding: 1.6rem;

  ${breakpoints.up('tablet')} {
    padding: 19rem 1.6rem;
  }
`

export const CardWrapper = styled(Card)``

export const Title = styled.h5`
  ${({ theme }) => theme.textStyles.H5};
  margin-bottom: 3.2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  align-items: center;
`

export const FieldCheckBox = styled(FormFieldCheckbox)`
  width: 100%;
  margin-bottom: 3.2rem;

  min-width: 25rem;

  ${breakpoints.up('tablet')} {
    min-width: 37rem;
  }
`

export const Errors = styled(FormErrors)``

export const SubmitButton = styled(FormSubmitButton)``
